import icons from '../../markons/markons';
import cn from 'classnames';
import css from './SubSection.less';

export default function SubSection({
                                       title,
                                       children,
                                       remove
                                   }: any) {
    return (
        <div className={css.container}>
            <div className={css.headerBar}>
                <h3 className={css.header}>{title}</h3>
                {remove ? <a className={cn(icons.ionTrashA, css.trash)} onClick={remove}/> : null}
            </div>
            <div className={css.content}>
                {children}
            </div>
        </div>

    )
}
